'use client'

import { fetchUserData } from '@/services/supabase/UserData'
import * as amplitude from '@amplitude/analytics-browser'
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser'
import { useEffect } from 'react'

let amplitudeInitialized = false

export default function Amplitude() {
  useEffect(() => {
    if (amplitudeInitialized) return

    const init = async () => {
      const userData = await fetchUserData()
      console.log('User Data for Amplitude:', userData)
      const AMPLITUDE_KEY = process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY
      if (!AMPLITUDE_KEY) {
        console.error('Amplitude API Key is missing')
        return
      }

      amplitude.init(
        AMPLITUDE_KEY,
        {
          defaultTracking: {
            sessions: true,
            pageViews: true,
          },
          fetchRemoteConfig: true,
        },
        userData.type === 'guest' ? undefined : userData.user.id
      )

      const sessionReplayTracking = sessionReplayPlugin({
        sampleRate: 50,
        forceSessionTracking: true,
      })
      amplitude.add(sessionReplayTracking)

      amplitudeInitialized = true
    }

    init()
  }, [])

  return null
}
